module.exports = __webpack_public_path__ + "img/vehicle-options-white-infiniti.7e9d2067.png";